var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMemo = function SvgIconMemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M376.081 121.932h-9.169l-65.229 203.663c-4.388 13.723-17.128 22.989-31.515 22.989H109.742l-2.316 7.255c-3.423 10.664 4.545 21.59 15.755 21.59h169.595c14.387 0 27.123-9.309 31.515-22.989l67.546-210.918c3.417-10.663-4.546-21.59-15.756-21.59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M412.894 173.504h-9.169l-65.229 203.662c-4.388 13.724-17.127 22.989-31.511 22.989h-160.43l-2.316 7.255c-3.418 10.664 4.545 21.59 15.755 21.59h169.595c14.388 0 27.128-9.309 31.516-22.989l67.545-210.917c3.422-10.664-4.545-21.59-15.756-21.59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M340.457 72H167.696c-26.223 0-26.223 13.111-29.5 21.59L92.452 241.442l-20.65 64.464c-3.423 10.664 4.544 21.59 15.755 21.59h169.595c14.387 0 27.123-9.309 31.515-23.032L356.212 93.59C359.63 82.926 351.667 72 340.457 72"
  })));
};
export default SvgIconMemo;